import {
  applicationEditableFieldApi,
  documentTypeExtractionFieldApi,
  documentTypeFieldsMappingApi,
} from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOC_EXTRACTION_MAPPING_ACTION_TYPE = createNamedActions('documentExtractionMapping', {
  GET_LOAN_FIELDS: 'GET_LOAN_FIELDS',
  GET_DOC_EXTRACTION_FIELDS_BY_DOC_TYPE_ID: 'GET_DOC_EXTRACTION_FIELDS_BY_DOC_TYPE_ID',
  ADD_NEW_DOC_EXTRACTION_MAPPING: 'ADD_NEW_DOC_EXTRACTION_MAPPING',
  GET_MAPPED_DOCUMENT_TYPES_LIST: 'GET_MAPPED_DOCUMENT_TYPES_LIST',
  GET_DOC_EXTRACTION_MAPPING_BY_DOC_TYPE_ID: 'GET_DOC_EXTRACTION_MAPPING_BY_DOC_TYPE_ID',
  EDIT_DOC_EXTRACTION_MAPPING: 'EDIT_DOC_EXTRACTION_MAPPING',
  DELETE_DOC_EXTRACTION_MAPPING: 'DELETE_DOC_EXTRACTION_MAPPING',
});

const fieldsMapping = new schema.Entity(
  'fieldsMapping',
  {},
  { idAttribute: 'documentFieldTypeId' },
);
const docExtractionMapping = new schema.Entity(
  'docExtractionMapping',
  {},
  { idAttribute: 'documentTypeId' },
);

export const getLoanFieldsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await applicationEditableFieldApi.getLoanFieldsTree();

  return dispatch({
    type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_LOAN_FIELDS,
    payload: data,
  });
});

export const getDocExtractionFieldsByDocTypeIdAction = catchAsyncActionError(
  ({ documentTypeId }) =>
    async dispatch => {
      const { data } =
        await documentTypeExtractionFieldApi.getDocumentTypeExtractionFieldByDocumentTypeId({
          typeId: documentTypeId,
        });

      return dispatch({
        type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_DOC_EXTRACTION_FIELDS_BY_DOC_TYPE_ID,
        payload: { documentTypeId, data },
      });
    },
);

export const createDocumentTypeFieldsMappingAction = catchAsyncActionError(
  body => async dispatch => {
    const { data } = await documentTypeFieldsMappingApi.createMapping(body);

    return dispatch({
      type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.ADD_NEW_DOC_EXTRACTION_MAPPING,
      payload: {
        ...data,
        ...normalize(data.fieldsMapping, [fieldsMapping]).entities,
      },
    });
  },
);

export const getDocumentTypeFieldsMappingAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await documentTypeFieldsMappingApi.getDocumentTypes();
  const normalizedData = normalize(
    data.map(documentTypeId => ({ documentTypeId })),
    [docExtractionMapping],
  ).entities;

  return dispatch({
    type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_MAPPED_DOCUMENT_TYPES_LIST,
    payload: normalizedData.docExtractionMapping || {},
  });
});

export const getDocumentTypeFieldsMappingByDocumentTypeIdAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentTypeFieldsMappingApi.getMappingByDocumentTypeId(params);

    return dispatch({
      type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_DOC_EXTRACTION_MAPPING_BY_DOC_TYPE_ID,
      payload: {
        ...data,
        ...normalize(data.fieldsMapping, [fieldsMapping]).entities,
      },
    });
  },
);

export const editDocumentTypeFieldsMappingAction = catchAsyncActionError(
  params => async dispatch => {
    // The response is ignored here, because BE sends a list with filled fields excluding empty fields
    await documentTypeFieldsMappingApi.updateMapping(params);

    return dispatch({
      type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.EDIT_DOC_EXTRACTION_MAPPING,
      payload: {
        ...params,
        ...normalize(params.fieldsMapping, [fieldsMapping]).entities,
      },
    });
  },
);

export const deleteDocumentTypeFieldsMappingAction = catchAsyncActionError(
  ({ documentTypeId }) =>
    async dispatch => {
      await documentTypeFieldsMappingApi.deleteMapping({ documentTypeId });

      return dispatch({
        type: DOC_EXTRACTION_MAPPING_ACTION_TYPE.DELETE_DOC_EXTRACTION_MAPPING,
        payload: documentTypeId,
      });
    },
);
